import ReactDOM from 'react-dom/client';
import React from 'react';
import { DeadDays } from './dead-days-config';
import { ToastContainer } from 'react-toastify';
import { TenantContext } from '../../../context/tenant-context';
import 'react-toastify/dist/ReactToastify.css';
import { v2Component } from '../../../index';

export function initDeadDaysConfig() {
  document.getElementsByName('dead-days-config').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const { tenant, contextPath, ...props } = Object.assign({}, element.dataset) as any;
      root.render(
        v2Component(
          <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
            <ToastContainer />
            <DeadDays {...props} />
          </TenantContext.Provider>,
        ),
      );

      const event = new CustomEvent('change');
      element.dispatchEvent(event);
    }
  });
}
